import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import moment from 'moment';
import MultiSelectUser from 'components/site/multi-user-search';
import DatePicker from 'react-datepicker';
import LocationSearch from 'components/site/location-search';
import OriginDsestinationSearch from 'components/site/origin-destination-search';
import { titleize } from 'underscore.string';
import FilterGroup from '../../equipment/FilterGroup';
import CargomaticPane from '../../../v2/pane';

function formatDate(date) {
  if (!date) {
    return date;
  }
  return moment(date);
}

export default function Filters({
  show,
  filters,
  filterValues,
  filterMetadata,
  onFilterChange,
  onHide,
}) {
  const { t } = useTranslation();
  function renderFilters() {
    return (
      <div data-testid="div-0da19077" className={sideBarClassName}>
        <div data-testid="div-09576a26" className="p-4">
          <h4 data-testid="h4-57bf01a2">{t('FILTER', { count: 2 })}</h4>
          {renderFilterGroups()}
        </div>
      </div>
    );
  }

  function renderMultiUserSearch(filterGroup) {
    const { key, customerType } = filterGroup;
    const type = t(key.toUpperCase());
    const placeholder = t(`SEARCH_FOR_TYPE`, {
      type,
    });
    return (
      <MultiSelectUser
        type={customerType}
        placeholder={placeholder}
        onSelect={(_value, item) => {
          onFilterChange(filterGroup, item, true);
        }}
        onRemove={(item) => {
          onFilterChange(filterGroup, item, false);
        }}
        selectedItems={filterMetadata[key]}
      />
    );
  }

  function renderOriginSearch(filterGroup) {
    return (
      <OriginDsestinationSearch
        filterMetadata={filterMetadata}
        filterGroup={filterGroup}
        onFilterChange={onFilterChange}
      />
    );
  }

  function renderDateFilters(filterGroup) {
    const key = filterGroup.key;
    const value = filterValues[key];

    const minDate = key === 'end_date' ? filterValues.start_date : null;
    const maxDate = key === 'start_date' ? filterValues.end_date : null;
    return (
      <div data-testid="div-f18c09e3" className="block mt-4 mb-4 date-filter">
        <DatePicker
          selected={formatDate(value)}
          className="w-full form-field"
          placeholderText={filterGroup.title}
          onChange={(e) => onFilterChange(filterGroup, e)}
          minDate={minDate}
          maxDate={maxDate}
        />
      </div>
    );
  }

  function renderFilterGroup(filterGroup) {
    if (filterGroup.type === 'customer') {
      return renderMultiUserSearch(filterGroup);
    }

    if (filterGroup.type === 'date') {
      return renderDateFilters(filterGroup);
    }

    if (filterGroup.type === 'location') {
      return renderOriginSearch(filterGroup);
    }
    return null;
  }

  function renderFilterGroups() {
    return filters.map((filterGroup, index) => {
      const title = titleize(t(filterGroup.name.toUpperCase()));
      const groupId = filterGroup.key;
      const renderedFilterGroup = renderFilterGroup(filterGroup);
      return (
        <FilterGroup
          dataTestId={`div-03d54c0e-${index}`}
          title={title}
          key={groupId}
        >
          {renderedFilterGroup}
        </FilterGroup>
      );
    });
  }

  const sideBarClassName = classnames({
    'w-full': true,
    'filters-sidebar': true,
    'bg-gray-50': true,
    'h-full': true,
    'mb-10': true,
  });
  return (
    <CargomaticPane
      dataTestId="CargomaticPane-47fd5e3d"
      container={null}
      show={show}
      title={t('FILTER')}
      onHide={onHide}
      renderBody={renderFilters}
    />
  );
}
